import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from './components/nuxt-error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_4432fec4 from 'nuxt_plugin_plugin_4432fec4' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_axios_0983ae98 from 'nuxt_plugin_axios_0983ae98' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_axios_2228ef02 from 'nuxt_plugin_axios_2228ef02' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_elementui_d905880e from 'nuxt_plugin_elementui_d905880e' // Source: ../plugins/element-ui (mode: 'all')
import nuxt_plugin_included_77048d72 from 'nuxt_plugin_included_77048d72' // Source: ../plugins/included.js (mode: 'all')
import nuxt_plugin_route_231494d5 from 'nuxt_plugin_route_231494d5' // Source: ../plugins/route (mode: 'client')
import nuxt_plugin_third_be172db8 from 'nuxt_plugin_third_be172db8' // Source: ../plugins/third.js (mode: 'client')
import nuxt_plugin_mapbox_1f695d98 from 'nuxt_plugin_mapbox_1f695d98' // Source: ../plugins/mapbox.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"产信宝","htmlAttrs":{"lang":"zh"},"meta":[{"charset":"utf-8"},{"http-equiv":"expires","content":"0"},{"http-equiv":"pragma","content":"no-cache"},{"http-equiv":"Cache-Control","content":"no-cache, must-revalidate"},{"http-equiv":"X-UA-Compatible","content":"IE=edge,chrome=1"},{"name":"renderer","content":"webkit|ie-comp|ie-stand"},{"name":"referrer","content":"no-referrer"},{"name":"HandheldFriendly","content":"true"},{"name":"keywords","content":"产信宝, 产业, 中国数字产业, 产业链, 供应链管理, 产业互联网, 工业互联网, 数字化转型, 产业升级, 智能制造, 产业生态, 产业集群, 产业物联网, 产业云平台, 产业数据分析, 制造业创新, 产业智能解决方案"},{"name":"description","content":"“产信宝”旨在为企业、园区、政府及产业研究等组织机构提供精准直观的产业发展信息，提高各级商事主体，组织机构决策效率。未来，公司将围绕“数字中国”这一国家战略，以服务产业数字化发展为初衷，进一步开拓大数据精准招商、产业发展研究及数字化运营服务等产品，运用线上线下服务体系，助推中国数字经济发展。"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"stylesheet","href":"\u002Flib\u002Fmapbox-gl.css"},{"rel":"stylesheet","href":"\u002Flib\u002Fanimate.min.css"}],"noscript":[{"innerHTML":"This website requires JavaScript."}],"script":[{"src":"\u002Flib\u002Fjquery.min.js","type":"text\u002Fjavascript","charset":"utf-8"},{"src":"https:\u002F\u002Fwebapi.amap.com\u002Fmaps?v=2.0&key=0fd2cecb75c30fa3cc666b57f5dd283c","type":"text\u002Fjavascript","charset":"utf-8","defer":false,"async":false,"crossorigin":"anonymous"},{"src":"\u002Flib\u002Fmaterialize.min.js","type":"text\u002Fjavascript","charset":"utf-8"},{"src":"\u002Flib\u002Fturf.js","type":"text\u002Fjavascript","charset":"utf-8"},{"src":"\u002Flib\u002Fmapbox-gl.js","type":"text\u002Fjavascript","charset":"utf-8"},{"src":"\u002Flib\u002Fxlsx.full.min.js","type":"text\u002Fjavascript","charset":"utf-8"},{"src":"\u002Flib\u002Fecharts.min.js","type":"text\u002Fjavascript","charset":"utf-8"},{"src":"\u002Flib\u002Fqrcode.min.js","type":"text\u002Fjavascript","charset":"utf-8"},{"src":"\u002Flib\u002FFileSaver.min.js","type":"text\u002Fjavascript","charset":"utf-8"},{"src":"\u002Flib\u002FwarterMarkJS.js","type":"text\u002Fjavascript","charset":"utf-8"},{"src":"\u002Flib\u002FpiroBox\u002FpiroBox.js","type":"text\u002Fjavascript","charset":"utf-8"}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_4432fec4 === 'function') {
    await nuxt_plugin_plugin_4432fec4(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_0983ae98 === 'function') {
    await nuxt_plugin_axios_0983ae98(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_2228ef02 === 'function') {
    await nuxt_plugin_axios_2228ef02(app.context, inject)
  }

  if (typeof nuxt_plugin_elementui_d905880e === 'function') {
    await nuxt_plugin_elementui_d905880e(app.context, inject)
  }

  if (typeof nuxt_plugin_included_77048d72 === 'function') {
    await nuxt_plugin_included_77048d72(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_route_231494d5 === 'function') {
    await nuxt_plugin_route_231494d5(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_third_be172db8 === 'function') {
    await nuxt_plugin_third_be172db8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_mapbox_1f695d98 === 'function') {
    await nuxt_plugin_mapbox_1f695d98(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
